// System
import { Suspense, useMemo } from 'react';
import { Tabs, Tab, Box, CircularProgress, Divider } from '@mui/material';

// Components
import { useTabs } from '@Components/shared/hooks/useTabs';

// Features
import { TransactionList } from '@Features/transaction/TransactionsList';
import { TransactionTitle } from '@Features/transaction/TransactionTitle/TransactionTitle';
import { ProviderTransactionsList } from '@Features/ProviderTransactions/ProviderTransactionList/ProviderTransactionsList';
import { ProviderTransactionsTitle } from '@Features/ProviderTransactions/ProviderTransactionTitle/ProviderTransactionTitle';
import { ProviderIgnoredRequestsList } from '@Features/providerIgnoredRequests/ProviderIgnoredRequestsList';
import { ProviderIgnoredRequestsTitle } from '@Features/providerIgnoredRequests/ProviderIgnoredRequestsTitle/ProviderIgnoredRequestsTitle';
import { FailedSendCreditTasksList } from '@Features/failedSendCreditTasks/FailedSendCreditTasksList';
import { FailedSendCreditTasksTitle } from '@Features/failedSendCreditTasks/FailedSendCreditTasksTitle/FailedSendCreditTasksTitle';
import { FailedSendCreditTransactionsList } from '@Features/failedSendCreditTransactions/FailedSendCreditTransactionsList';
import { ScheduledSendCreditTasksList } from '@Features/scheduledSendCreditTasks/ScheduledSendCreditTasksList';
import { FailedSendCreditTransactionsTitle } from '@Features/failedSendCreditTransactions/FailedSendCreditTransactionsTitle/FailedSendCreditTransactionsTitle';
import { ScheduledSendCreditTasksTitle } from '@Features/scheduledSendCreditTasks/ScheduledSendCreditTasksTitle/ScheduledSendCreditTasksTitle';

const panels = [
  TransactionList,
  ProviderTransactionsList,
  ProviderIgnoredRequestsList,
  FailedSendCreditTasksList,
  FailedSendCreditTransactionsList,
  ScheduledSendCreditTasksList,
];
const titles = [
  TransactionTitle,
  ProviderTransactionsTitle,
  ProviderIgnoredRequestsTitle,
  FailedSendCreditTasksTitle,
  FailedSendCreditTransactionsTitle,
  ScheduledSendCreditTasksTitle,
];

export const TransactionPage = () => {
  const { currentTab, handleSwithTab } = useTabs(0);
  const Component = useMemo(() => panels[currentTab], [currentTab]);
  const Title = useMemo(() => titles[currentTab], [currentTab]);

  return (
    <>
      <Title />
      <Tabs value={currentTab} onChange={handleSwithTab}>
        <Tab label="Round Transactions" />
        <Tab label="Provider Transactions" />
        <Tab label="Provider Ignored Requests" />
        <Tab label="Failed Send Credit Tasks" />
        <Tab label="Failed Send Credit Transactions" />
        <Tab label="Scheduled Send Credit Tasks" />
      </Tabs>
      <Divider />
      <Box sx={{ paddingTop: 3, paddingBottom: 2 }}>
        <Suspense fallback={<CircularProgress />}>
          <Component />
        </Suspense>
      </Box>
    </>
  );
};
